// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import SideMenu from "../components/SideMenu";
// import Header from "../components/Header";
// import webexdummyimg from "../assets/images/webexdummyimg.png";
// import DoneOutlineTwoToneIcon from "@mui/icons-material/DoneOutlineTwoTone";

// import { sendOtp, setVerified } from "../redux-store/slices/otpSlice"; // Import the sendOtp action
// import axios from "axios";
// import API_BASE_URL from "../utilities/ApiConfig";
// import { toast } from "react-toastify";
// import ApiLoader from "../components/ApiLoader";

// const WebexFormTest = () => {
//   const location = useLocation();
//   const { dcode, srocode } = useSelector((state) => state?.auth?.userDetails);
//   const dispatch = useDispatch();
//   const otpStore = useSelector((state) => state.otp); // Get stored OTPs
//   const isOtpVerified = (pcode) => !!otpStore?.[pcode]?.verified;
//   const [loading, setLoading] = useState(false);

//   const [enteredOtps, setEnteredOtps] = useState({}); // Store entered OTPs
//   const [otpValues, setOtpValues] = useState({}); // Store OTP field values

//   const selectedTokenDetails = location?.state?.selectedTokenDetails;
//   const partyDetailsModeFromRegistrationTokenList = location?.state?.mode;
//   const postponedPartyDetails = location?.state?.partyListData;

//   const meetingLink = sessionStorage.getItem("meetingLink");
//   console.log(meetingLink);

//   const handleMeeting = () => {
//     if (meetingLink) {
//       window.open(meetingLink, "_blank");
//     } else {
//       alert("Meeting link not available.");
//     }
//   };

//   const updateMeetingInWebex = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.put(
//         `https://webex.eregistrationukgov.in/api/Webex/update-meeting?meetingLink=${meetingLink}`,
//         { sendEmail: true, hostEmail: "dehradunddn04@gmail.com" }
//       );
//       if (response.status === 200) {
//         toast.success("Meeting link resent successfully!");
//       } else {
//         toast.error("Failed to resend meeting link.");
//       }
//     } catch (error) {
//       console.error("Error updating Webex meeting:", error);
//       alert("An error occurred while resending the meeting link.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResendMeetingLink = async () => {
//     if (!meetingLink) {
//       alert("Meeting link not found!");
//       return;
//     }
//     await updateMeetingInWebex();
//   };

//   const [registeredPartyList, setRegisteredPartyList] = useState([]);
//   useEffect(() => {
//     const fetchPartyDetails = async () => {
//       try {
//         const { tokenDate, tokenNo } = selectedTokenDetails?.[0] || {};
//         if (partyDetailsModeFromRegistrationTokenList !== "POSTPONED") {
//           const response = await axios.get(
//             `${API_BASE_URL}/Registration/get_party_details_modewise_using_dcode_srocode_token_date_token_no/${dcode}/${srocode}/${tokenDate}/${tokenNo}/${partyDetailsModeFromRegistrationTokenList}`
//           );
//           if (response.data?.statusCode === 200) {
//             setRegisteredPartyList(
//               response.data?.registeredPartyDetailsList || []
//             );
//           }
//         } else {
//           setRegisteredPartyList(postponedPartyDetails || []);
//         }
//       } catch (error) {
//         console.error("Error fetching party details:", error);
//       }
//     };

//     fetchPartyDetails();
//   }, [selectedTokenDetails]);

//   const handleOtpChange = (pcode, value, index) => {
//     setOtpValues((prev) => {
//       const updatedOtp = { ...prev[pcode], [index]: value };
//       return { ...prev, [pcode]: updatedOtp };
//     });
//     if (value && index < 3) {
//       document.getElementById(`${pcode}-${index + 1}`).focus();
//     }
//   };

//   const handleOtpKeyDown = (e, pcode, index) => {
//     if (e.key === "Backspace" && !otpValues[pcode][index] && index > 0) {
//       document.getElementById(`${pcode}-${index - 1}`).focus();
//     }
//   };

//   const handleVerifyOtp = (pcode) => {
//     const enteredOtp = Object.values(otpValues[pcode] || {}).join("");
//     const storedOtp = otpStore?.[pcode]?.otp;

//     if (storedOtp && enteredOtp === storedOtp) {
//       dispatch(setVerified({ pcode, verified: true })); // Mark as verified
//     } else {
//       dispatch(setVerified({ pcode, verified: false })); // Mark as not verified
//       toast.error("Invalid OTP. Please try again.");
//     }
//   };

//   const handleSendOtp = (pcode, mobileNo) => {
//     dispatch(sendOtp({ mobileNo, pcode }));
//   };

//   const firstPartyDetails = registeredPartyList.filter((party) =>
//     party.pcode.startsWith("01")
//   );
//   const secondPartyDetails = registeredPartyList.filter((party) =>
//     party.pcode.startsWith("02")
//   );
//   const witnessDetails = registeredPartyList.filter((party) =>
//     party.pcode.startsWith("03")
//   );

//   const maskMobile = (mobileNo) => {
//     if (!mobileNo || mobileNo.length < 10) return "N/A";
//     return mobileNo.slice(0, 2) + "*****" + mobileNo.slice(-3);
//   };

//   const maskAadhaar = (aadhaarNo) => {
//     if (!aadhaarNo || aadhaarNo.length < 12) return "N/A";
//     return aadhaarNo.slice(0, 2) + "** **** " + aadhaarNo.slice(-4);
//   };

//   const renderPartyDetails = (title, details) => {
//     if (details.length === 0) return null;
//     return (
//       <div className="mt-2">
//         <h2 className="text-lg font-bold mb-2">{title}</h2>
//         <div className="grid grid-cols-3 gap-4">
//           {details.map((party) => {
//             const otpVerified = otpStore?.[party.pcode]?.verified;

//             return (
//               <div key={party.pcode} className="flex flex-row items-start">
//                 <img
//                   src={party.image || webexdummyimg}
//                   alt="Profile"
//                   className="w-24 h-28 mb-2"
//                 />
//                 <div className="text-start ml-4">
//                   <div className="flex items-center justify-between mb-2 space-x-4">
//                     <p className="font-medium text-gray-700">Full Name:</p>
//                     <p className="text-gray-900">{party.nameEng || "N/A"}</p>
//                   </div>

//                   {/* Aadhaar */}
//                   <div className="flex items-center justify-between mb-2">
//                     <h1 className="font-medium text-gray-700">Aadhaar:</h1>
//                     <p className="text-gray-900 text-start ml-3">
//                       {maskAadhaar(party.idNo)}
//                     </p>
//                   </div>

//                   <div className="flex items-center justify-between mb-2 space-x-4">
//                     <p className="font-medium text-gray-700">Mobile No:</p>
//                     <p className="text-gray-900">
//                       {maskMobile(party.mobileNo)}
//                     </p>
//                   </div>

//                   <div className="flex items-center justify-between mb-2 space-x-4">
//                     <p className="font-medium text-gray-700">Status:</p>
//                     <p
//                       className={`px-2 py-1 text-xs text-white rounded-full ${
//                         otpVerified ? "bg-green-500" : "bg-red-500"
//                       }`}
//                     >
//                       {otpVerified ? "Verified" : "Not Verified"}
//                     </p>

//                     {!otpVerified && (
//                       <button
//                         onClick={() =>
//                           handleSendOtp(party.pcode, party.mobileNo)
//                         }
//                         className="text-sm text-[#4F9CF9]"
//                       >
//                         Send OTP
//                       </button>
//                     )}
//                   </div>

//                   {!otpVerified && otpStore?.[party.pcode] && (
//                     <div className="flex items-center ml-14">
//                       <div className="flex space-x-2">
//                         {Array(4)
//                           .fill("")
//                           .map((_, index) => (
//                             <input
//                               key={index}
//                               id={`${party.pcode}-${index}`}
//                               type="text"
//                               maxLength="1"
//                               value={otpValues[party.pcode]?.[index] || ""}
//                               onChange={(e) =>
//                                 handleOtpChange(
//                                   party.pcode,
//                                   e.target.value,
//                                   index
//                                 )
//                               }
//                               onKeyDown={(e) =>
//                                 handleOtpKeyDown(e, party.pcode, index)
//                               }
//                               className="w-6 h-6 text-center border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//                             />
//                           ))}
//                       </div>
//                       <button
//                         onClick={() => handleVerifyOtp(party.pcode)}
//                         className="text-sm text-[#4F9CF9] ml-4"
//                       >
//                         Verify
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <>
//       {loading && <ApiLoader />}

//       <div className="flex h-screen overflow-hidden">
//         <SideMenu />
//         <div className="flex-1 flex flex-col">
//           <Header />
//           <div className="flex-1 overflow-y-auto">
//             <div className="flex-1 p-4">
//               <div className="min-h-screen bg-[#ffffff] p-6">
//                 <div className="p-6 rounded-lg shadow-md bg-[#F4F4F4]">
//                   {/* Header Section */}
//                   <div className="grid gap-4 mb-2 3xl:mb-6">
//                     <div>
//                       <div className="flex items-center space-x-4 mb-4">
//                         <span className="border border-[#CBCBCB] shadow-sm bg-[#F5F5F5] px-3 py-1 rounded">
//                           Book No. : 1
//                         </span>
//                         <span className="border border-[#CBCBCB] shadow-sm bg-[#F5F5F5] px-3 py-1 rounded">
//                           Token No. :{" "}
//                           {selectedTokenDetails?.[0]?.tokenNo || "N/A"}
//                         </span>
//                         <span className="border border-[#CBCBCB] shadow-sm bg-[#F5F5F5] px-3 py-1 rounded">
//                           Token Year:{" "}
//                           {selectedTokenDetails?.[0]?.regYear || "N/A"}
//                         </span>
//                       </div>
//                       <div className="flex items-center space-x-4 mb-4">
//                         <span className="border border-[#CBCBCB] shadow-sm bg-[#F5F5F5] px-3 py-1 rounded">
//                           Deed. : Sale
//                         </span>
//                         <span className="border border-[#CBCBCB] shadow-sm bg-[#F5F5F5] px-3 py-1 rounded">
//                           Sub Deed. : Sale Immovable
//                         </span>
//                       </div>
//                       <div className="flex items-center space-x-4 mb-4">
//                         <button
//                           className="bg-blue-500 text-white px-6 py-2 rounded"
//                           onClick={handleMeeting}
//                         >
//                           Start Video Meeting
//                         </button>
//                         <button
//                           onClick={handleResendMeetingLink}
//                           className="text-[#4F9CF9] underline px-3 py-1 rounded"
//                         >
//                           Resend Meeting Link
//                         </button>
//                         <span className="text-[#666666] px-3 py-1 rounded">
//                           (Scheduled meeting timing: 12:25 IST, 25/08/2024)
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Party Details Section */}
//                   {renderPartyDetails("First Party Details", firstPartyDetails)}
//                   {renderPartyDetails(
//                     "Second Party Details",
//                     secondPartyDetails
//                   )}
//                   {renderPartyDetails("Witness Details", witnessDetails)}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default WebexFormTest;

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import webexdummyimg from "../assets/images/webexdummyimg.png";

import { sendOtp, setVerified } from "../redux-store/slices/otpSlice"; // Import the sendOtp action
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import ApiLoader from "../components/ApiLoader";

const WebexFormTest = () => {
  const location = useLocation();
  const { dcode, srocode } = useSelector((state) => state?.auth?.userDetails);
  const dispatch = useDispatch();
  const otpStore = useSelector((state) => state.otp); // Get stored OTPs
  // const isOtpVerified = (pcode) => !!otpStore?.[pcode]?.verified;
  const isOtpVerified = (pcode, pdeId) =>
    !!otpStore?.[`${pdeId}_${pcode}`]?.verified;
  console.log(isOtpVerified);
  debugger;
  const [loading, setLoading] = useState(false);

  const [enteredOtps, setEnteredOtps] = useState({}); // Store entered OTPs
  const [otpValues, setOtpValues] = useState({}); // Store OTP field values

  const selectedTokenDetails = location?.state?.selectedTokenDetails;
  const pdeId = location?.state?.pdEid;
  debugger;
  const partyDetailsModeFromRegistrationTokenList = location?.state?.mode;
  const postponedPartyDetails = location?.state?.partyListData;

  const meetingLink = sessionStorage.getItem("meetingLink");
  // const [showWebex, setShowWebex] = useState(false);
  console.log(meetingLink);

  const handleMeeting = () => {
    if (meetingLink) {
      window.open(meetingLink, "_blank");
    } else {
      alert("Meeting link not available.");
    }
  };

  // const handleMeeting = () => {
  //   if (meetingLink) {
  //     setShowWebex(true); // show the floating player
  //   } else {
  //     alert("Meeting link not available.");
  //   }
  // };

  const updateMeetingInWebex = async () => {
    try {
      setLoading(true);
      const response = await axios.put(
        `https://webex.eregistrationukgov.in/api/Webex/update-meeting?meetingLink=${meetingLink}`,
        { sendEmail: true, hostEmail: "dehradunddn04@gmail.com" }
      );
      if (response.status === 200) {
        toast.success("Meeting link resent successfully!");
      } else {
        toast.error("Failed to resend meeting link.");
      }
    } catch (error) {
      console.error("Error updating Webex meeting:", error);
      alert("An error occurred while resending the meeting link.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendMeetingLink = async () => {
    if (!meetingLink) {
      alert("Meeting link not found!");
      return;
    }
    await updateMeetingInWebex();
  };

  const [registeredPartyList, setRegisteredPartyList] = useState([]);
  useEffect(() => {
    const fetchPartyDetails = async () => {
      try {
        const { tokenDate, tokenNo } = selectedTokenDetails?.[0] || {};
        if (partyDetailsModeFromRegistrationTokenList !== "POSTPONED") {
          const response = await axios.get(
            `${API_BASE_URL}/Registration/get_party_details_modewise_using_dcode_srocode_token_date_token_no/${dcode}/${srocode}/${tokenDate}/${tokenNo}/${partyDetailsModeFromRegistrationTokenList}`
          );
          debugger;
          if (response.data?.statusCode === 200) {
            setRegisteredPartyList(
              response.data?.registeredPartyDetailsList || []
            );
            debugger;
          }
        } else {
          setRegisteredPartyList(postponedPartyDetails || []);
        }
      } catch (error) {
        console.error("Error fetching party details:", error);
      }
    };

    fetchPartyDetails();
  }, [selectedTokenDetails]);

  const handleOtpChange = (pcode, value, index) => {
    setOtpValues((prev) => {
      const updatedOtp = { ...prev[pcode], [index]: value };
      return { ...prev, [pcode]: updatedOtp };
    });
    if (value && index < 3) {
      document.getElementById(`${pcode}-${index + 1}`).focus();
    }
  };

  const handleOtpKeyDown = (e, pcode, index) => {
    if (e.key === "Backspace" && !otpValues[pcode][index] && index > 0) {
      document.getElementById(`${pcode}-${index - 1}`).focus();
    }
  };

  const handleVerifyOtp = async (pcode) => {
    const enteredOtp = Object.values(otpValues[pcode] || {}).join("");
    const storedOtp = otpStore?.[`${pdeId}_${pcode}`]?.otp;
    //const storedOtp = otpStore?.[pcode]?.otp;

    if (storedOtp && enteredOtp === storedOtp) {
      // dispatch(setVerified({ pcode, verified: true }));
      dispatch(setVerified({ pkey: `${pdeId}_${pcode}`, verified: true }));

      try {
        const res = await axios.post(
          `${API_BASE_URL}/VideoMeetingStatus/verify-party-otp`,
          {
            PDE_ID: pdeId,
            Pcode: pcode,
            Email:
              registeredPartyList.find((p) => p.pcode === pcode)?.email || "",
            Moblieno: registeredPartyList.find((p) => p.pcode === pcode)
              ?.mobileNo,
            Verification: "Y",
          }
        );
        debugger;
        if (res.status === 200 && res.data?.status === "Success") {
          toast.success(`OTP for ${pcode} verified and saved.`);
        } else {
          toast.error(`OTP for ${pcode} verified but status not saved.`);
        }
      } catch (error) {
        console.error(`Error saving OTP for ${pcode}:`, error);
        toast.error(`An error occurred verifying OTP for ${pcode}.`);
      }
    } else {
      dispatch(setVerified({ pcode, verified: false }));
      toast.error(`Invalid OTP for ${pcode}. Please try again.`);
    }
  };

  const handleSendOtp = (pcode, mobileNo) => {
    dispatch(sendOtp({ mobileNo, pcode, pdeId }));
  };

  const firstPartyDetails = registeredPartyList.filter((party) =>
    party.pcode.startsWith("01")
  );
  const secondPartyDetails = registeredPartyList.filter((party) =>
    party.pcode.startsWith("02")
  );
  const witnessDetails = registeredPartyList.filter((party) =>
    party.pcode.startsWith("03")
  );

  const maskMobile = (mobileNo) => {
    if (!mobileNo || mobileNo.length < 10) return "N/A";
    return mobileNo.slice(0, 2) + "*****" + mobileNo.slice(-3);
  };

  const maskAadhaar = (aadhaarNo) => {
    if (!aadhaarNo || aadhaarNo.length < 12) return "N/A";
    return aadhaarNo.slice(0, 2) + "** **** " + aadhaarNo.slice(-4);
  };

  const renderPartyDetails = (title, details) => {
    if (details.length === 0) return null;
    return (
      <div className="mt-2">
        <h2 className="text-lg font-bold mb-2">{title}</h2>
        <div className="grid grid-cols-3 gap-4">
          {details.map((party) => {
            // const otpVerified = otpStore?.[party.pcode]?.verified;
            const otpVerified = otpStore?.[`${pdeId}_${party.pcode}`]?.verified;

            return (
              <div key={party.pcode} className="flex flex-row items-start">
                {/* <img
                  src={party.photo || webexdummyimg}
                  alt="Profile"
                  className="w-24 h-28 mb-2"
                /> */}
                <img
                  src={
                    party.photo
                      ? `data:image/jpeg;base64,${party.photo}`
                      : webexdummyimg
                  }
                  alt="Profile"
                  className="w-24 h-28 mb-2"
                />

                <div className="text-start ml-4">
                  <div className="flex items-center justify-between mb-2 space-x-4">
                    <p className="font-medium text-gray-700">Full Name:</p>
                    <p className="text-gray-900">{party.nameEng || "N/A"}</p>
                  </div>

                  {/* Aadhaar */}
                  <div className="flex items-center justify-between mb-2">
                    <h1 className="font-medium text-gray-700">Aadhaar:</h1>
                    <p className="text-gray-900 text-start ml-3">
                      {maskAadhaar(party.idNo)}
                    </p>
                  </div>

                  <div className="flex items-center justify-between mb-2 space-x-4">
                    <p className="font-medium text-gray-700">Mobile No:</p>
                    <p className="text-gray-900">
                      {maskMobile(party.mobileNo)}
                    </p>
                  </div>

                  <div className="flex items-center justify-between mb-2 space-x-4">
                    <p className="font-medium text-gray-700">Status:</p>
                    <p
                      className={`px-2 py-1 text-xs text-white rounded-full ${
                        otpVerified ? "bg-green-500" : "bg-red-500"
                      }`}
                    >
                      {otpVerified ? "Verified" : "Not Verified"}
                    </p>

                    {!otpVerified && (
                      <button
                        onClick={() =>
                          handleSendOtp(party.pcode, party.mobileNo)
                        }
                        className="text-sm text-[#4F9CF9]"
                      >
                        Send OTP
                      </button>
                    )}
                  </div>

                  {!otpVerified && otpStore?.[`${pdeId}_${party.pcode}`] && (
                    <div className="flex items-center ml-14">
                      <div className="flex space-x-2">
                        {Array(4)
                          .fill("")
                          .map((_, index) => (
                            <input
                              key={index}
                              id={`${party.pcode}-${index}`}
                              type="text"
                              maxLength="1"
                              value={otpValues[party.pcode]?.[index] || ""}
                              onChange={(e) =>
                                handleOtpChange(
                                  party.pcode,
                                  e.target.value,
                                  index
                                )
                              }
                              onKeyDown={(e) =>
                                handleOtpKeyDown(e, party.pcode, index)
                              }
                              className="w-6 h-6 text-center border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                          ))}
                      </div>
                      <button
                        onClick={() => handleVerifyOtp(party.pcode)}
                        className="text-sm text-[#4F9CF9] ml-4"
                      >
                        Verify
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      {loading && <ApiLoader />}

      <div className="flex h-screen overflow-hidden">
        <SideMenu />
        <div className="flex-1 flex flex-col">
          <Header />
          <div className="flex-1 overflow-y-auto">
            <div className="flex-1 p-4">
              <div className="min-h-screen bg-[#ffffff] p-6">
                <div className="p-6 rounded-lg shadow-md bg-[#F4F4F4]">
                  {/* Header Section */}
                  <div className="grid gap-4 mb-2 3xl:mb-6">
                    <div>
                      <div className="flex items-center space-x-4 mb-4">
                        <span className="border border-[#CBCBCB] shadow-sm bg-[#F5F5F5] px-3 py-1 rounded">
                          Book No. : 1
                        </span>
                        <span className="border border-[#CBCBCB] shadow-sm bg-[#F5F5F5] px-3 py-1 rounded">
                          Token No. :{" "}
                          {selectedTokenDetails?.[0]?.tokenNo || "N/A"}
                        </span>
                        <span className="border border-[#CBCBCB] shadow-sm bg-[#F5F5F5] px-3 py-1 rounded">
                          Token Year:{" "}
                          {selectedTokenDetails?.[0]?.regYear || "N/A"}
                        </span>
                      </div>
                      <div className="flex items-center space-x-4 mb-4">
                        <span className="border border-[#CBCBCB] shadow-sm bg-[#F5F5F5] px-3 py-1 rounded">
                          Deed. : Sale
                        </span>
                        <span className="border border-[#CBCBCB] shadow-sm bg-[#F5F5F5] px-3 py-1 rounded">
                          Sub Deed. : Sale Immovable
                        </span>
                      </div>
                      <div className="flex items-center space-x-4 mb-4">
                        <button
                          className="bg-blue-500 text-white px-6 py-2 rounded"
                          onClick={handleMeeting}
                        >
                          Start Video Meeting
                        </button>
                        <button
                          onClick={handleResendMeetingLink}
                          className="text-[#4F9CF9] underline px-3 py-1 rounded"
                        >
                          Resend Meeting Link
                        </button>
                        <span className="text-[#666666] px-3 py-1 rounded">
                          (Scheduled meeting timing: 12:25 IST, 25/08/2024)
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Party Details Section */}
                  {renderPartyDetails("First Party Details", firstPartyDetails)}
                  {renderPartyDetails(
                    "Second Party Details",
                    secondPartyDetails
                  )}
                  {renderPartyDetails("Witness Details", witnessDetails)}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {showWebex && (
          <FloatingWebexPlayer
            meetingDestination={meetingLink}
            onClose={() => setShowWebex(false)}
          />
        )} */}
      </div>
    </>
  );
};

export default WebexFormTest;
